import React, { useState } from 'react';
import BrushIcon from '@mui/icons-material/Brush';
import { IconButton, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DeleteIcon from '@mui/icons-material/Delete';
import { useTranslation } from 'react-i18next';
import styles from './ContactCard.module.scss';
import MessageModal from '../message-modal/MessageModal';
import { useCheckPermission } from '../hooks/useCheckPermission';
import { USER_PERMISSIONS } from '../constants/permissions';

interface ContactDropdownProps {
  onEdit: () => void;
  onDelete: () => void;
}

export const ContactDropdown = ({ onEdit, onDelete }: ContactDropdownProps) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [deleteMessageModalOpen, setDeleteMessageModalOpen] = useState(false);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const checkPermission = useCheckPermission();

  return (
    <>
      {deleteMessageModalOpen && (
        <MessageModal
          open={deleteMessageModalOpen}
          modalTitle={t('messages.deleteContact')}
          modalMessage={t('messages.deleteBusinessContactDialog')}
          actionButtonText={t('buttons.goBack')}
          actionButtonFn={() => setDeleteMessageModalOpen(false)}
          goBackButtonText={t('buttons.delete')}
          onClose={() => {
            onDelete();
          }}
        />
      )}
      <IconButton
        aria-label={t('labels.menuButton')}
        onClick={handleClick}
        className={styles.add_button_size}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem
          onClick={() => {
            handleClose();
            onEdit();
          }}
          disabled={!checkPermission(USER_PERMISSIONS.ORG_BUSINESS_PROFILE_UPDATE_CONTACT)}
        >
          <BrushIcon style={{ marginRight: 8 }} />
          {t('buttons.edit')}
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClose();
            setDeleteMessageModalOpen(true);
          }}
          disabled={!checkPermission(USER_PERMISSIONS.ORG_BUSINESS_PROFILE_DELETE_CONTACT)}
        >
          <DeleteIcon style={{ marginRight: 8 }} />
          {t('buttons.delete')}
        </MenuItem>
      </Menu>
    </>
  );
};

export default ContactDropdown;
